// extracted by mini-css-extract-plugin
export default {"arrowButton":"ArrowButton_arrowButton__mBfA4","arrow":"ArrowButton_arrow__xuxfN","left":"ArrowButton_left__EzYNI","right":"ArrowButton_right__burnG"};